import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,              // 30s — data considered fresh
      gcTime: 5 * 60 * 1000,          // 5m — unused data stays in cache
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
